/* ============================================================
   Equijump · Theault custom PDP
   Finance calculator + stock carousel.
   Two independent IIFEs. Vanilla. No deps.
   (Gallery is handled by Tinker's native media-gallery component.)
   ============================================================ */

/* ---------- Finance calculator -----------------------------
   PMT = (PV * r) / (1 - (1 + r)^(-n))
   ------------------------------------------------------------ */
(function () {
  const calc = document.getElementById('calc');
  if (!calc) return;

  const fmt  = new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
  const fmt2 = new Intl.NumberFormat('en-IE', { maximumFractionDigits: 2, minimumFractionDigits: 2 });

  const totalEl   = document.getElementById('calcTotal');
  const depositEl = document.getElementById('calcDeposit');
  const monthsEl  = document.getElementById('calcMonths');
  const rateEl    = document.getElementById('calcRate');

  const totalDisp = document.getElementById('calcTotalDisplay');
  const depoDisp  = document.getElementById('calcDepositDisplay');
  const monDisp   = document.getElementById('calcMonthsDisplay');
  const rateDisp  = document.getElementById('calcRateDisplay');

  const outMonthly = document.getElementById('calcMonthly');
  const outTotal   = document.getElementById('calcTotalCost');
  const outInt     = document.getElementById('calcInterest');
  const outLoan    = document.getElementById('calcLoan');
  const outTerm    = document.getElementById('calcTermLabel');

  if (!totalEl || !depositEl || !monthsEl || !rateEl) return;

  function run() {
    let total   = Math.max(0, parseFloat(totalEl.value) || 0);
    let deposit = Math.max(0, parseFloat(depositEl.value) || 0);
    if (deposit > total) deposit = total;
    const months  = parseInt(monthsEl.value, 10);
    const ratePct = parseFloat(rateEl.value);
    const r = ratePct / 100 / 12;
    const PV = total - deposit;

    let monthly;
    if (r === 0) {
      monthly = months > 0 ? PV / months : 0;
    } else {
      monthly = (PV * r) / (1 - Math.pow(1 + r, -months));
    }
    if (!isFinite(monthly) || isNaN(monthly)) monthly = 0;

    const totalCost = (monthly * months) + deposit;
    const interest  = (monthly * months) - PV;
    const years     = months / 12;
    const yearLabel = (years === Math.floor(years)) ? years : years.toFixed(1);

    totalDisp.innerHTML  = fmt.format(total) + '<span class="calc-field-value-sub">ex VAT</span>';
    depoDisp.textContent = fmt.format(deposit);
    monDisp.innerHTML    = months + ' <span class="calc-field-value-sub">months</span>';
    rateDisp.innerHTML   = fmt2.format(ratePct) + ' <span class="calc-field-value-sub">% APR</span>';

    outMonthly.innerHTML = fmt.format(monthly) + '<span class="per">/ mo</span>';
    outTotal.textContent = fmt.format(totalCost);
    outInt.textContent   = fmt.format(Math.max(0, interest));
    outLoan.textContent  = fmt.format(PV);
    outTerm.textContent  = yearLabel + (yearLabel == 1 ? ' year' : ' years');

    /* Reflect monthly back into the hero finance line if present. */
    const heroFin = document.querySelector('[data-theault-finance-monthly]');
    if (heroFin) heroFin.textContent = fmt.format(monthly);
  }

  ['input', 'change'].forEach(function (evt) {
    [totalEl, depositEl, monthsEl, rateEl].forEach(function (el) {
      el.addEventListener(evt, run);
    });
  });

  run();
})();

/* ---------- Testimonial shuffle -----------------------------
   Liquid emits every Theault-tagged testimonial. We shuffle the cards
   client-side and keep only the first N visible (default 3). With 3 or
   fewer cards the shuffle is a no-op.
   ------------------------------------------------------------ */
(function () {
  const root = document.querySelector('[data-theault-tm-shuffle]');
  if (!root) return;
  const grid = root.querySelector('[data-tm-grid]');
  if (!grid) return;
  const cards = Array.prototype.slice.call(grid.children);
  if (cards.length <= 1) return;

  /* Fisher-Yates */
  for (let i = cards.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const tmp = cards[i];
    cards[i] = cards[j];
    cards[j] = tmp;
  }

  const visible = parseInt(root.getAttribute('data-tm-visible'), 10) || 3;

  /* Re-attach in shuffled order, hiding overflow. */
  const frag = document.createDocumentFragment();
  cards.forEach(function (card, idx) {
    if (idx >= visible) {
      card.style.display = 'none';
      card.setAttribute('aria-hidden', 'true');
    }
    frag.appendChild(card);
  });
  grid.appendChild(frag);
})();

/* ---------- Pre-built stock carousel ----------------------- */
(function () {
  const car  = document.getElementById('stockCarousel');
  const prev = document.getElementById('stockPrev');
  const next = document.getElementById('stockNext');
  if (!car || !prev || !next) return;

  function scrollAmount() {
    const card = car.querySelector('.stock-card');
    if (!card) return 320;
    const style = window.getComputedStyle(car);
    const gap = parseInt(style.gap, 10) || 16;
    return card.getBoundingClientRect().width + gap;
  }
  function updateButtons() {
    const max = car.scrollWidth - car.clientWidth - 2;
    prev.disabled = car.scrollLeft <= 2;
    next.disabled = car.scrollLeft >= max;
  }
  prev.addEventListener('click', function () { car.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }); });
  next.addEventListener('click', function () { car.scrollBy({ left:  scrollAmount(), behavior: 'smooth' }); });
  car.addEventListener('scroll', updateButtons, { passive: true });
  window.addEventListener('resize', updateButtons);
  updateButtons();
})();
